<template>
  <div :class="ui.bkgdColor">
      <v-layout class="text-xs-right mt-2 mr-2">
        <v-spacer/>
        <v-btn :color="ui.textSubheading"
        :disabled="getRiskAssessmentList.length > 30 || !this.enableDocumentItemAdd()"
        flat icon @click="openDialog()">
          <v-icon :color="ui.btnColor"> add </v-icon>
        </v-btn>
      <v-dialog v-model="dialog" :max-width="ui.sizeWidthDialogLarge">
        <v-card :color="ui.bkgdColor" :text-color="ui.bkgdColor">
          <v-card-title :class="ui.textTitle">
            New Risk Assessment
          </v-card-title>
          <v-progress-linear color="blue-grey" height="1" value="100">
          </v-progress-linear>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-container>
              <v-layout row :class="ui.textSubheading">
                <div class="ml-4 mt-4">
                  Risk Identification
                </div>
              </v-layout>
              <v-layout row class="ml-2 mr-2">
                <v-flex xs10>
                  <v-text-field
                  v-model="localForm.title"
                  label="risk assessment title"
                  :rules="ruleMustBeFilledANDLessThan50"
                  prepend-icon="title"
                  required
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="ml-2 mr-2">
                <v-flex xs10 sm5>
                  <v-text-field
                  v-model="localForm.id"
                  label="risk id"
                  :rules="ruleMustBeFilledANDLessThan50"
                  prepend-icon="sell"
                  required
                  ></v-text-field>
                </v-flex>
                <v-flex xs10 sm5>
                  <v-text-field
                  v-model="localForm.ref"
                  label="reference"
                  :rules="ruleMustBeNotUndefinedANDLessThan50"
                  prepend-icon="share"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row :class="ui.textSubheading">
                <div class="ml-4 mt-4">
                  Scenario and Context
                </div>
              </v-layout>
              <v-layout row class="ml-4 mr-4 mt-4">
                <v-flex xs11>
                  <v-textarea
                  v-model="localForm.com"
                  :disabled="false"
                  :outline="true"
                  :rules="mustBeLessThanLarge"
                  hint="risk assessment and outcome description"
                  label="risk scenario with barriers and controls"
                  auto-grow
                  persistent-hint
                  ></v-textarea>
                </v-flex>
              </v-layout>
              <v-layout row :class="ui.textSubheading">
                <div class="ml-4 mt-4">
                  Barriers and Risk Controls
                </div>
              </v-layout>
              <v-layout row wrap class="mr-2">
                <v-flex xs10 offset-xs1>
                  <v-text-field
                  v-model="localForm.cause"
                  label="potential causes"
                  :rules="ruleMustBeNotUndefinedANDLessThan50"
                  prepend-icon="low_priority"
                  hint="causes (the why)"
                  persistent-hint
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row class="mr-2">
                <v-flex xs10 offset-xs1>
                  <v-text-field
                  v-model="localForm.bar"
                  label="existing barriers"
                  :rules="ruleMustBeNotUndefinedANDLessThan50"
                  prepend-icon="shield"
                  required
                  hint="risk barriers (prevent event)"
                  persistent-hint
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row class="mr-2">
                <v-flex xs10 offset-xs1>
                  <v-text-field
                  v-model="localForm.cont"
                  label="risk controls"
                  :rules="ruleMustBeNotUndefinedANDLessThan50"
                  prepend-icon="health_and_safety"
                  hint="risk controls (reduce escalation)"
                  required
                  persistent-hint
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="mr-2">
                <v-flex xs10 sm5 offset-xs1 offset-sm1>
                  <v-select
                  v-model="localForm.bars"
                  :items="riskStrengthStatusOptions"
                  prepend-icon="assessment"
                  hint="barrier stat."
                  persistent-hint
                  required
                  >
                </v-select>
                </v-flex>
                <v-flex xs10 sm5 offset-xs1>
                  <v-select
                  v-model="localForm.conts"
                  :items="riskStrengthStatusOptions"
                  prepend-icon="analytics"
                  hint="control stat."
                  persistent-hint
                  required
                  >
                </v-select>
                </v-flex>
              </v-layout>
              <v-layout row :class="ui.textSubheading">
                <div class="ml-4 mt-4">
                  Risk Assessment
                </div>
                <v-spacer/>
                <div class="ml-4 mt-4 mr-4"
                v-if="riskValueCalc(this.localForm.cons, this.localForm.like) > 0">
                  <div :class="ui.textSubheadingWarning">
                    Risk = {{riskValueCalc(this.localForm.cons, this.localForm.like)}}
                  </div>
                </div>
              </v-layout>
              <v-layout row wrap class="mr-2">
                <v-flex xs10 sm5 offset-xs1 offset-sm1>
                  <v-select
                  v-model="localForm.type"
                  :items="riskAssessmentTypeOptions"
                  prepend-icon="emergency"
                  label="type"
                  hint="risk type"
                  :rules="ruleMustBeSelected"
                  persistent-hint
                  required
                  >
                </v-select>
                </v-flex>
                <v-flex xs10 sm5 offset-xs1>
                  <v-text-field
                  v-model="localForm.comp"
                  prepend-icon="today"
                  hint="compliance"
                  label="reg."
                  :rules="ruleMustBeNotUndefinedANDLessThan50"
                  persistent-hint
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="mr-2">
                <v-flex xs10 sm5 offset-xs1 offset-sm1>
                  <v-select
                  v-model="localForm.cond"
                  :items="riskAssessmentConditionOptions"
                  prepend-icon="swap_horizontal_circle"
                  label="condition"
                  :rules="ruleMustBeSelected"
                  hint="risk condition"
                  persistent-hint
                  required
                  >
                </v-select>
                </v-flex>
                <v-flex xs10 sm5 offset-xs1>
                  <v-select
                  v-model="localForm.time"
                  :items="riskAssessmentTimeOptions"
                  prepend-icon="schedule"
                  label="timing"
                  :rules="ruleMustBeSelected"
                  hint="risk timing"
                  persistent-hint
                  required
                  >
                </v-select>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="mr-2">
                <v-flex xs10 sm5 offset-xs1 offset-sm1>
                  <v-select
                  v-model="localForm.cat"
                  :items="riskCategoryOptions"
                  prepend-icon="scatter_plot"
                  label="category"
                  hint="risk category"
                  :rules="ruleMustBeSelected"
                  persistent-hint
                  required
                  >
                </v-select>
                </v-flex>
                <v-flex xs10 sm5 offset-xs1>
                  <v-text-field
                  v-model="localForm.rate"
                  prepend-icon="leaderboard"
                  hint="risk rating"
                  :label="riskRatingCalc(this.localForm.cons, this.localForm.like)"
                  persistent-hint
                  readonly
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="mr-2">
                <v-flex xs10 sm5 offset-xs1 offset-sm1>
                  <v-select
                  v-model="localForm.cons"
                  :items="riskConsequenceOptions"
                  label="consequence"
                  :rules="ruleMustBeSelected"
                  prepend-icon="local_fire_department"
                  hint="consequence"
                  required
                  >
                </v-select>
                </v-flex>
                <v-flex xs10 sm5 offset-xs1>
                  <v-select
                  v-model="localForm.like"
                  :items="riskLikelihoodOptions"
                  label="likelihood"
                  :rules="ruleMustBeSelected"
                  prepend-icon="casino"
                  hint="likelihood"
                  >
                  </v-select>
                </v-flex>
              </v-layout>
              <v-layout row class="mr-2">
                <v-flex xs10 offset-xs1>
                  <v-text-field
                  v-model="localForm.sum"
                  label="conclusion"
                  :rules="ruleMustBeFilledANDLessThan50"
                  prepend-icon="adjust"
                  required
                  hint="risk assessment conclusion"
                  persistent-hint
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
          <v-layout row>
            <v-btn @click="closeDialog()" color="wplblue0" flat>
              <v-icon left> exit_to_app </v-icon>
              Close
            </v-btn>
            <v-spacer/>
            <v-btn @click="validate" color="wplblue0" flat>
              <v-icon left> add </v-icon>
              add
            </v-btn>
          </v-layout>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import rulesTextfield from "@/data/rules/mixins/rulesTextfield.js";
import master from "@/data/forms/mixins/master.js";
import listFunctions from "@/data/functions/mixins/listFunctions.js";
import documentFunctions from "@/data/functions/mixins/documentFunctions.js";
import generateForms from "@/data/functions/mixins/generateForms.js";
import riskOptions from "@/data/options/mixins/riskOptions.js";
import riskFunctions from "@/data/functions/mixins/riskFunctions.js";
import causeOptions from "@/data/options/mixins/causeOptions.js";
import uisettings from "@/frame/theme/mixins/uisettings.js";
import docRevsModFunctions from "@/document/revisions/mixins/docRevsModFunctions.js";
import generateID from "@/data/cloud/firebase/mixins/generateID.js";
import moment from "moment";

export default {
  // eslint-disable-next-line
  mixins: [
    generateForms,
    riskOptions,
    riskFunctions,
    causeOptions,
    listFunctions,
    master,
    rulesTextfield,
    uisettings,
    generateID,
    docRevsModFunctions,
    documentFunctions
  ],
  computed: {
    // eslint-disable-next-line
    ...mapGetters([
      "getRiskAssessmentList",
      "getRiskAssessmentListCounter",
      "getRiskAssessmentListRiskCounter",
      "getRiskAssessmentListDisplay",
      "getCurrentPage",
      "getDetail",
      "getUser"
    ]),
    ui() {
      return this.uiTheme1;
    }
  },
  data() {
    return {
      dialog: false,
      valid: false,
      enableSpinner: false,
      localForm: {
        title: "Risk Title 1", // title
        type: "Basieline",
        id: "R1", // risk id
        ref: "", // reference
        com: "Risk assessment is", // risk comms
        cat: "Production", // category prior
        cons: "C", // consequence
        like: "4", // liklekhood
        risk: "", // current risk
        rate: "", // current rate D4
        time: "HD1", // timing
        cond: "Operations",
        rank: "", // rank
        calc: "", // risk calculation
        comp: "", // compliance risk
        sum: "Tolerable", // risk summary and closeing comments
        cause: "", // potentail causes
        bar: "", // barriers that can be take credit for this outcome
        bars: "", // barriers that can be take credit for this outcome
        barr: "",
        cont: "", // controls, baseline, or more
        contr: "",
        conts: "" // controls, status
      }
    };
  },
  methods: {
    closeDialog() {
      this.dialog = false;
    },
    openDialog() {
      this.dialog = true;
      // this.$store.dispatch("changeRiskAssessmentList", []);
      // this.$refs.form.reset();
    },
    validate() {
      // cosole.log(this.taskForm)
      if (this.$refs.form.validate() === true) {
        // set up temporray riskAssessment form
        var tempList = this.getRiskAssessmentList;
        var tempForm = this.generateRiskAssessmentForm();
        console.log(tempForm);
        // add additional info to task list
        if (tempList === undefined) {
          // if undefined make it defined
          this.$store.dispatch("changeRiskAssessmentList", []);
          tempForm.basic.idi = 1;
        } else if (tempList.length === 0) {
          tempForm.basic.idi = 1;
        } else {
          // eslint-disable-next-line
          tempForm.basic.idi = this.getRiskAssessmentListCounter + 1;
        }

        // BASIC
        tempForm.basic.idg = this.generateIDG("date-gid");
        tempForm.basic.did = this.generateDID("DATE", "S2");
        tempForm.basic.tag = "S2";
        // CHAR
        tempForm.basic.title = this.localForm.title;
        tempForm.basic.id = this.localForm.id;
        tempForm.char.com = this.localForm.com;
        tempForm.char.cause = this.localForm.cause;
        tempForm.char.bar = this.localForm.bar;
        tempForm.char.bars = this.localForm.bars;
        tempForm.char.cont = this.localForm.cont;
        tempForm.char.conts = this.localForm.conts;
        tempForm.char.cat = this.localForm.cat;
        tempForm.char.cons = this.localForm.cons;
        tempForm.char.like = this.localForm.like;
        tempForm.char.type = this.localForm.type;
        tempForm.char.time = this.localForm.time;
        tempForm.char.cond = this.localForm.cond;
        tempForm.char.comp = this.localForm.comp;
        tempForm.char.sum = this.localForm.sum;
        tempForm.char.ref = this.localForm.ref;
        // STATS who added / edited it
        tempForm.stats.date = moment().format();
        tempForm.stats.uname = this.getUser.basic.title;
        tempForm.stats.uemail = this.getUser.basic.email;
        tempForm.stats.udid = this.getUser.basic.did;

        // LIST UPDATE
        tempList = this.getRiskAssessmentList;
        var obj = Object.assign({}, tempForm);
        var parseobj = JSON.parse(JSON.stringify(obj));
        var newList = this.appendItemLimited(parseobj, tempList, 50);

        // STORE UPDATE
        // eslint-disable-next-line
        this.$store.dispatch("changeRiskAssessmentList", newList);
        // eslint-disable-next-line
        this.$store.dispatch("changeRiskAssessmentListCounter", tempForm.basic.idi);
        this.saveDocumentRevMod(5.11, 1); // attachment added.
        this.$store.dispatch("changeDataSavePendingIndication", true);
        // eslint-disable-next-line
        let riskCounter = this.calcRiskTotal(this.getRiskAssessmentList);
        // eslint-disable-next-line
        this.$store.dispatch("changeRiskAssessmentListRiskCounter", riskCounter);

        // Close Window
        this.dialog = false;
      }
    }
  }
};
</script>
